import { type ReactNode, useContext, useEffect } from 'react'
import { useSearchParams } from 'react-router'
import StoreTrajectories from './store-trajectories'
import StoreTrajectoryEdit from './edit/store-trajectory-edit'
import StoreTrajectoryProvider from './state/store-trajectory-provider'
import { StoreTrajectoryContext } from './state/store-trajectory-context'
import StoreTrajectoryConsult from './consult/store-trajectory-consult'
import StoreTrajectoryValidate from './consult/store-trajectory-validate'

export const StoreTrajectoryListPage = () => (
  <StoreTrajectoryProvider>
    <StoreTrajectories />
  </StoreTrajectoryProvider>
)

export const StoreTrajectoryEditPage = () => (
  <StoreTrajectoryProvider>
    <StoreTrajectoryGuard component={<StoreTrajectoryEdit />} />
  </StoreTrajectoryProvider>
)

export const StoreTrajectoryConsultPage = () => (
  <StoreTrajectoryProvider>
    <StoreTrajectoryGuard component={<StoreTrajectoryConsult />} />
  </StoreTrajectoryProvider>
)

export const StoreTrajectoryValidatePage = () => (
  <StoreTrajectoryProvider>
    <StoreTrajectoryGuard component={<StoreTrajectoryValidate />} />
  </StoreTrajectoryProvider>
)

const parseYearParam = (value: string | null) => {
  if (value === null) {
    return null
  }
  const parsedYear = Number.parseInt(value, 10)
  return Number.isNaN(parsedYear) ? null : parsedYear
}

interface StoreTrajectoryGuardProps {
  component: ReactNode
}

const StoreTrajectoryGuard = ({ component }: StoreTrajectoryGuardProps) => {
  const { setTargetYear, targetYear } = useContext(StoreTrajectoryContext)
  const [searchParams] = useSearchParams()
  const yearFromUrl = parseYearParam(searchParams.get('year'))

  useEffect(() => {
    if (yearFromUrl !== null && targetYear !== yearFromUrl) {
      setTargetYear(yearFromUrl)
    }
  }, [setTargetYear, yearFromUrl])

  return component
}
